import { render, staticRenderFns } from "./encartPhoto.vue?vue&type=template&id=0f985614"
import script from "./encartPhoto.vue?vue&type=script&lang=js"
export * from "./encartPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports